import { Box, Divider, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  calculateSubtotalPrice,
  calculateTotalPrice,
} from "../../../shared/functions/calculateTotalPrice";
import { formatInvoiceFooter } from "../../../shared/functions/formatInvoiceFooter";

import { formatPrice } from "../../../shared/functions/formatPrice";
import { IInvoiceItem } from "../../../shared/interfaces/invoice/IInvoice";
import { lightPalette } from "../../../shared/mui/palettes";
import { footerInvoiceKeys } from "./InvoicePreview";

interface IProps {
  taxes: number;
  discount: number;
  items: IInvoiceItem[];
}
const InvoiceFooterCalculation = ({ taxes, items, discount }: IProps) => {
  const { t } = useTranslation();
  return (
    <>
      {footerInvoiceKeys?.map((footerKey) => {
        const value =
          footerKey === "taxes"
            ? taxes
            : footerKey === "discount"
              ? discount
              : calculateSubtotalPrice(items ?? []);
        return (
          <React.Fragment key={footerKey}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                my: "10px",
              }}
            >
              <Typography color={lightPalette.text.gray} variant={"subtitle2"}>
                {t(`invoice.${footerKey}`)}:
              </Typography>
              <Typography
                variant={"subtitle2"}
                color={lightPalette.text.gray}
                sx={{
                  fontWeight: "300",
                }}
              >
                {formatInvoiceFooter(footerKey, Number(value || 0))}
              </Typography>
            </Box>
            <Divider />
          </React.Fragment>
        );
      })}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          my: "10px",
        }}
      >
        <Typography sx={{ fontWeight: "600" }}>
          {t(`invoice.total`)}:
        </Typography>
        <Typography
          sx={{
            fontWeight: "600",
          }}
        >
          {formatPrice(calculateTotalPrice(items ?? [], taxes, discount))}
        </Typography>
      </Box>
    </>
  );
};

export default InvoiceFooterCalculation;
